import { create } from 'zustand'
import {
  FILTER_LIST_OPTIONS,
  FilterValues,
  SelectedFIlterTypes
} from '../components/Filter-Component/utils'
import CommonApi from '@/pages/api'

interface SelectFieldOptions {
  id: number | string
  value: number | string
  name: string
}
interface FilterStore {
  test: string
  isReset: boolean
  selectedFilter: SelectedFIlterTypes[]
  appliedFilter: SelectedFIlterTypes[]
  staticFilterList: number[]
  filterValues: FilterValues
  appliedValues: FilterValues
  filterModal: boolean
  jobList: SelectFieldOptions[]
  inverse_req: SelectFieldOptions[]
  activeQuickFilter: boolean
  setSelectedFilter: (val: SelectedFIlterTypes[]) => void
  setAppliedFilter: (val: SelectedFIlterTypes[]) => void
  setStaticFilterList: (val: number[]) => void
  setFilterValues: (val: FilterValues) => void
  setAppliedValues: (data: FilterValues) => void
  setFilterModal: (val: boolean) => void
  getFiltersData: () => void
  setActiveQuickFilter: (val: boolean) => void
  setIsRest: (value: boolean) => void
}

export const filterStore = create<FilterStore>((set, get) => ({
  test: 'hello',
  isReset: false,
  selectedFilter: [
    {
      id: 1,
      options: FILTER_LIST_OPTIONS,
      defaultValue: 'Select'
    }
  ],
  appliedFilter: [
    // {
    //   id: 9,
    //   options: FILTER_LIST_OPTIONS,
    //   defaultValue: "Select",
    // },
  ],
  staticFilterList: [0],
  filterValues: {},
  appliedValues: {
    // 9: { name: "status", value: ["active"] }
  },
  filterModal: false,
  jobList: [],
  inverse_req: [],
  activeQuickFilter: false,
  setSelectedFilter: (val: SelectedFIlterTypes[]) => {
    set({ selectedFilter: val })
  },
  setAppliedFilter: (val: SelectedFIlterTypes[]) => {
    set({ appliedFilter: val })
  },
  setStaticFilterList: (val: number[]) => {
    set({ staticFilterList: val })
  },
  setFilterValues: (val: FilterValues) => {
    set({ filterValues: val })
  },
  setAppliedValues: (val: FilterValues) => {
    set({ appliedValues: val })
  },
  setFilterModal: (val: boolean) => {
    set({ filterModal: val })
  },
  setIsRest: value => {
    set({ isReset: value })
  },
  getFiltersData: async () => {
    try {
      const resp = await CommonApi({
        path: 'filters-data',
        method: 'get'
      })
      if (resp.status) {
        set({
          jobList: resp.data.jobs_list.map((item: string) => {
            if (item) {
              return {
                name: item,
                id: item,
                value: item
              }
            }
          }),
          inverse_req: resp.data.inv_recruiter_dict.map((item: { name: string; id: number }) => {
            if (item) {
              return {
                name: item.name,
                id: item.id,
                value: item.id
              }
            }
          })
        })
      }
    } catch (err) {
      console.log('err:', err)
    }
  },
  setActiveQuickFilter: (val: boolean) => {
    set({ activeQuickFilter: val })
  }
}))
